import { createTestingI18nObject } from '@evidation/testing-utils';

import { enUS } from './en-US';

const testingTranslations = createTestingI18nObject(enUS);
export default testingTranslations;
